module.exports = __webpack_public_path__ + "static/media/tick-circle.ab4fd931.svg";